import $ from "jquery";

const feedbackForm = document.querySelector(
  ".js-feedback-form"
) as HTMLInputElement;

if (feedbackForm) {
  const yesBtn = document.querySelector(".js-feedback-yes");
  const noBtn = document.querySelector(".js-feedback-no");
  const form = feedbackForm.querySelector("form") as HTMLFormElement;
  const radioYes = feedbackForm.querySelector(
    'input[value="Yes"]'
  ) as HTMLInputElement;
  const radioNo = feedbackForm.querySelector(
    'input[value="No"]'
  ) as HTMLInputElement;
  const urlInputWrapper = feedbackForm.querySelector(
    ".page"
  ) as HTMLInputElement;
  const urlInput = urlInputWrapper.querySelector(
    'input[type="hidden"]'
  ) as HTMLInputElement;
  const submitBtn = feedbackForm.querySelector(
    '[type="submit"]'
  ) as HTMLInputElement;

  $(yesBtn).on("click", e => {
    e.preventDefault();
    const btn = e.currentTarget;
    btn.classList.remove("btn--primary");
    btn.classList.add("btn--secondary");
    radioYes.checked = true;
    if (urlInput) {
      urlInput.value = window.location.pathname;
    } else {
      console.log("Page field missing from Feedback form");
    }

    submitFeedback(form);
  });

  $(noBtn).on("click", e => {
    e.preventDefault();
    const btn = e.currentTarget;
    btn.classList.remove("btn--primary");
    btn.classList.add("btn--secondary");
    feedbackForm.classList.add("feedback__form--open");
    radioNo.checked = true;
    if (urlInput) {
      urlInput.value = window.location.pathname;
    } else {
      console.log("Page field missing from Feedback form");
    }
  });

  $(".js-feedback-form .btn[type=submit]").on("click", e => {
    e.preventDefault();

    submitFeedback(form);
  });
}

function submitFeedback(form: HTMLFormElement) {
  if ($(form).valid()) {
    $.ajax({
      cache: false,
      data: $(form).serialize(),
      type: "POST",
      url: $(form).attr("action"),
      success(result) {
        $(".js-feedback-content").html("<h4>Thank you for your feedback</h4>");
      }
    });
  }
}
